export const CLUSTER_COLORS = [
  '#185A7C', '#E86C4B', '#47a36d', '#7c6daa', '#2a9d8f',
  '#d4851e', '#c0392b', '#5b8c5a', '#8ab5cc', '#b07d4f', '#6b7280'
];
